module.exports = __webpack_public_path__ + "img/avatar-5.e32b3ee9.png";